import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { ITierProductHighlights } from "api/interfaces/get-page-details/product-page.type";
import classNames from "classnames";
import WaterMark from "component/design-system/WaterMark";
import PAImage from "component/design-system/images/PAImage";
import ProductTagsCategory from "component/product/product-tags/ProductTagsCategory";
import SafeLink from "modules/components/SafeLink";
import { useTranslation } from "next-i18next";
import { getProductHeading } from "util/product/get-product-heading";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";
import { getThumbmailSrc, getThumbnailSrcV2 } from "../../../util/product/getThumbmailSrc";
import styles from "./productCards.module.scss";

interface IProps {
  productHighlights: ITierProductHighlights[],
  imageHeight?: number,
  imageWidth?: number,
  product: ICompactProduct
  src?: string
  hrefProps?: string;
  asPathProps?: string;
  isGridView?: boolean;
  imageClassName?: string;
  imageWrapperClassName?: string;
}

function ProductImage(props: IProps) {
  const {
    product, productHighlights, imageHeight, imageWidth, hrefProps, asPathProps, isGridView = false,
    src, imageClassName, imageWrapperClassName,
  } = props;
  const { productTags, canonicalUrl } = product;
  let updatedHref = hrefProps;
  let updatedAsPath = asPathProps;
  if (!hrefProps) {
    const { href, asPath } = getHrefAndPath({ asPath: canonicalUrl });
    updatedHref = href;
    updatedAsPath = asPath;
  }
  const { t } = useTranslation("common");
  const thumbnailV2 = getThumbnailSrcV2(product);
  const thumbnail = getThumbmailSrc(product);

  return (

    <div className={classNames(styles.product_image_container, { [styles.product_image_container_grid]: isGridView })}>
      <ProductTagsCategory
        productTags={productTags}
        productHighlights={productHighlights}
      />
      <SafeLink href={updatedHref} asPath={updatedAsPath} title={`Upgrade Your Vehicle With ${getProductHeading(product)}`}>
        <div className={classNames(styles.image_wrapper, imageWrapperClassName)}>
          {product.outOfStock && (
            <WaterMark label={t("OUT OF STOCK")} fontSize={0} />
          )}

          <PAImage
            width={imageWidth || 150}
            height={imageHeight || 150}
            src={src || (thumbnailV2 || thumbnail)}
            alt={`Order ${getProductHeading(product)} For Your Vehicle`}
            title={`Order ${getProductHeading(product)} For Your Vehicle`}
            className={classNames(styles.img_margin, imageClassName)}
          />
          <div className={styles.brand_logo}>
            <PAImage
              src={getRelativeImagePath(product.manufacturerSmallImageUrl)}
              width={115}
              height={30}
              alt={`Boost Your Vehicle's Potential with ${product.manufacturer} Parts`}
              title={`Boost Your Vehicle's Potential with ${product.manufacturer} Parts`}
            />
          </div>
        </div>
      </SafeLink>
    </div>

  );
}

export default ProductImage;
